// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1s0Qj","emails":"CreateEditClinics_emails__1jOh7","emailTagLabel":"CreateEditClinics_emailTagLabel__A2bly"};